import * as React from "react"
import { Form } from "antd"
import PropTypes from "prop-types"
import TextInput from "../TextInput/TextInput"
import "./TextAreaEdit.scss"

const TextAreaEdit = ({
  title, // text for collapsed version and either input field label or placeholder text
  label, // if true add field label; if not, add input placeholder instead
  inputProps,
  name,
  size,
  open: openProp,
  className,
}) => {
  const [open, setOpen] = React.useState()
  const textInputRef = React.useRef(null)

  // parent controls open state
  React.useEffect(() => {
    if (openProp) setOpen(true)
  }, [openProp])

  // focus when open to textarea
  React.useEffect(() => {
    if (open && textInputRef?.current) {
      textInputRef?.current.focus()
    }
  }, [open, textInputRef?.current])

  let classNames = ["text-area-edit"]
  if (open) {
    classNames.push("text-area-edit-open")
    if (inputProps?.className) classNames.push(inputProps.className)
  } else {
    classNames.push("text-area-edit-closed")
  }
  if (size === "large") {
    classNames.push("text-area-edit-large")
  } else {
    classNames.push("text-area-edit-default")
  }

  const getPlaceholder = () => {
    if (!label) {
      return title
    }
    return null
  }

  const getLabel = () => {
    if (label) {
      if (typeof label === "string") {
        return label
      } else if (typeof label === "boolean") {
        return title
      }
    }
    return null
  }

  if (open)
    return (
      <Form.Item
        label={getLabel()}
        name={name}
        className={className}
      >
        <TextInput
          ref={textInputRef}
          type="textarea"
          placeholder={getPlaceholder()}
          allowClear
          onBlur={({ target }) => {
            setTimeout(() => {
              if (!target.value) {
                setOpen(false)
              }
            }, 200)
          }}
          {...inputProps}
          className={classNames.join(" ")}
        />
      </Form.Item>
    )

  return (
    <div
      onClick={() => setOpen(true)}
      className={className}
    >
      {title} <i className="far fa-pen" />
    </div>
  )
}

TextAreaEdit.propTypes = {
  title: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  defaultOpen: PropTypes.bool,
  inputProps: PropTypes.object,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  size: PropTypes.oneOf(["default", "large"]),
}

export default TextAreaEdit
